import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { ChatMessage, SharePayload, Topic } from '../../common/types/interfaces'
import { ChatScreens, TopicScreens } from '../../common/types/enums'
import { JSX } from 'react'

const initialState: {
  topics: Topic[]
  modalActive: boolean
  topicScreen: TopicScreens
  screen: ChatScreens
  currentTopic?: Topic | undefined
  sharePayload?: SharePayload
} = {
  topics: [],
  modalActive: false,
  screen: ChatScreens.LIST,
  topicScreen: TopicScreens.UN_ARCHIVED,
  currentTopic: undefined,
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setSharePayload: (state, action: PayloadAction<SharePayload | undefined>) => {
      state.sharePayload = action.payload
    },
    setChatModalState: (state, action: PayloadAction<boolean>) => {
      state.modalActive = action.payload
    },
    updateIdByUuid: (state, action: PayloadAction<Topic>) => {
      state.topics = [
        ...state.topics.filter((el) => el.uuid !== action.payload.uuid),
        action.payload,
      ]
    },
    toggleChatModalState: (state) => {
      state.modalActive = !state.modalActive
    },
    setChatScreen: (state, action: PayloadAction<ChatScreens>) => {
      state.screen = action.payload
    },
    setTopicScreen: (state, action: PayloadAction<TopicScreens>) => {
      state.topicScreen = action.payload
    },
    setCurrentTopic: (state, action: PayloadAction<Topic | undefined>) => {
      state.currentTopic = action.payload
    },
    setTopicList: (state, action: PayloadAction<Topic[]>) => {
      state.topics = [...action.payload]
    },
    addTopic: (state, action: PayloadAction<Topic>) => {
      state.topics = [...state.topics, action.payload]
    },
    markAsRead: (state, action: PayloadAction<ChatMessage>) => {
      const topic = state.topics.find((el) => el.id === action.payload.topicId)
      if (topic) {
        state.topics = [...state.topics.filter((el) => el.id !== topic.id)]
        topic.messages = [...topic.messages.filter((el) => el.uuid !== action.payload.uuid)]
        topic.messages = [...topic.messages, action.payload]
        state.topics = [...state.topics, topic]
      }
    },
    addMessageToTopicById: (state, action: PayloadAction<ChatMessage>) => {
      const topic = state.topics.find((el) => el.id === action.payload.topicId)
      if (topic) {
        state.topics = [...state.topics.filter((el) => el.id !== topic.id)]
        topic.messages = [...topic.messages, action.payload]
        state.topics = [...state.topics, topic]
      }
    },
  },
})

export const { addTopic } = chatSlice.actions
export const { updateIdByUuid } = chatSlice.actions
export const { setTopicList } = chatSlice.actions
export const { setChatModalState } = chatSlice.actions
export const { setChatScreen } = chatSlice.actions
export const { setTopicScreen } = chatSlice.actions
export const { setCurrentTopic } = chatSlice.actions
export const { toggleChatModalState } = chatSlice.actions
export const { addMessageToTopicById } = chatSlice.actions
export const { markAsRead } = chatSlice.actions
export const { setSharePayload } = chatSlice.actions

export const selectTopics = (state: RootState) => state.chat.topics
export const selectChatModalActive = (state: RootState) => state.chat.modalActive
export const selectChatScreen = (state: RootState) => state.chat.screen
export const selectTopicScreen = (state: RootState) => state.chat.topicScreen
export const selectCurrentTopic = (state: RootState) => state.chat.currentTopic
export const selectSharePayload = (state: RootState) => state.chat.sharePayload

export default chatSlice.reducer
